import { FunctionComponent } from "react";
import { Navigate, useParams } from "react-router-dom";

import { OpsReportDisplay } from "@components/OpsReportDisplay";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { withPermissions } from "@components/withPermissions";
import { useOpsReportInstance } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

import { SystemEnvTabs } from "./system-env-tabs.constants";

const OpsReportBase: FunctionComponent = () => {
  const { name } = useParams<{ name: string }>();

  const instanceQuery = useOpsReportInstance(name, {});

  if (!name)
    return <Navigate to={`/system/env/${SystemEnvTabs.User.Manage.id}`} />;

  return (
    <QueryStateIndicator {...instanceQuery}>
      {instance => <OpsReportDisplay embedConfig={instance} />}
    </QueryStateIndicator>
  );
};

export const OpsReport = withPermissions(
  OpsReportBase,
  [Permissions.OpsReportRead, Permissions.OpsConsolePreRelease],
  "and"
);
